import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import es from "./locales/es.json";
import de from "./locales/de.json";

const saved = localStorage.getItem("lang");
const browser = (navigator.language || "en").slice(0, 2);
const initial = (saved || browser) as "en" | "es" | "de";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
    de: { translation: de },
  },
  lng: ["en", "es", "de"].includes(initial) ? initial : "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  detection: {
    order: ["localStorage", "navigator"],
    caches: ["localStorage"],
  },
});

export default i18n;
